
import React from 'react';
import image from '../../CustomAssets/Images/logo.png';  
import image_1 from '../../CustomAssets/Images/logo1.png';  
import '../../CustomAssets/Css/Components/Logo.css';

const Image = ({ src, clsNm }) => (
  <img decoding="async" className={clsNm} src={src} alt="mainLogo" />
);

export const Logo = ({ clsNm }) => <Image src={image} clsNm={clsNm} />;
export const Logo1 = ({ clsNm }) => <Image src={image_1} clsNm={clsNm} />;

